<template lang="html">
  <div class="wrapper">

    <div class="mojioglasi" >
      <h2>Izmeni oglas</h2>
      <br>
              <p class="nazad" @click="setedit(false)"><i class="fas fa-arrow-left"></i> Nazad</p>
            <div class="foto" >
              <div class="">
                  <div class="avatar-upload"  v-for="(n,index) in image" :id="'pocetna'+index">
                        <p style="position:absolute">{{index+1}}. Sl. <span v-if="index == 0"> - Početna</span> </p><br>
                    <img style="margin-bottom:10px;float: left;" v-if="n.url2":src="n.url2" alt="">
                    <croppa v-if="!n.url2" v-model="n.croppa"
                    placeholder="Odaberite fotografiju"
                    :placeholder-font-size="14"
                    :disabled="false"
                    :prevent-white-space="true"
                   :file-size-limit="5072000"
                   :accept="'.jpeg, .jpg, .png'"
                   @file-type-mismatch="onFileTypeMismatch"
                   :canvas-color="'white'"
                    @image-remove="handleImageRemove(index)"
                    initial-size="cover"
                    @init=""
                    @new-image-drawn="handleNewImage(index)"
                    placeholder-color="#4565db"
                    :canvas-width='image[index].sirina'
                    :canvas-height='image[index].visina'
                    :width='image[index].sirina'
                    :height='image[index].visina'
                    :zoom-speed="10"
                     :remove-button-size="20"
                    :initial-image="n.url">
                    </croppa>
                    <div class="dugmici">
                      <i style="float:right" class="fas fa-portrait" @click="landscape(index)"></i>
                      <i class="far fa-image" @click="portret(index)"></i>
                      <i class="fas fa-trash-alt" style="right:8px" v-if="n.url2" @click="obrisisliku(index)" title="Obrisi"></i>
                      <i class="fas fa-sync-alt" style="left:8px" v-if="n.is && !n.url2" @click="n.croppa.rotate(-1)" title="Rotiraj"></i>
                      <i class="fas fa-check" style="right:8px" v-show="n.is && !n.url2" @click="sacuvajsliku(index)" title="Sačuvaj"></i>
                    </div>


                  </div>
              </div>






                  <button type="button" @click="sacuvaj()" name="button">Sačuvaj izmene</button>
                    <router-link style="float:left; margin-left:3%" to="oglasi" class="nazad"><button type="button"name="button">Odustani</button></router-link>



            </div>
            <label for="textarea"> Opis oglasa:</label>
            <div id="editor">
             <vue-editor useCustomImageHandler  v-model="opis"></vue-editor>
           </div>
      </div>

  </div>

</template>

<script>
import { VueEditor } from "vue2-editor";
import imageCompression from 'browser-image-compression'
import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
  components: {
   imageCompression,
   VueEditor
 },
  data () {
    return {
      htmlForEditor: "",
      image:[
        {'url':"", url2:'', position:"",sirina:150, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        {'url':"", url2:'', position:"",sirina:300, visina:200, do:false, 'is':false, croppa:{} },
        ],
        opis:"",
        err:null,
        objslike:[null, null, null, null, null,null,null,null,null]



    }
  },
created(){
  var broj = this.singlpics.length
  for (var i = 0; i < broj; i++) {
      this.image[i].url = this.prourl + this.singlpics[i].sl_id
      this.image[i].is = true
      }
this.opis = this.singlpro.pro_opis
},
computed:{

          ...mapGetters([
            'edit',
            'prourl',
            'singlpro',
            'singlpics'
          ]),
},
  methods:{
    portret(i){
      this.image[i].sirina=300
      this.image[i].visina=200
    },
    landscape(i){
      this.image[i].sirina=150
      this.image[i].visina=200
    },
    obrisisliku(i){
      this.image[i].url2 = ""
      this.image[i].url = ""
      this.objslike[i] = null
      this.image[i].is = false
    },
    sacuvajsliku(i){
        this.image[i].url2 = this.image[i].croppa.generateDataUrl('image/jpeg', 0.9)
        this.image[i].croppa.generateBlob((blob) => {
                  this.objslike[i]= blob
              }, 'image/jpeg', 0.9)
    },
    handleImageRemove(i){
      // console.log('obrisano sa polja - ' + i);
      this.objslike[i]= null
      this.image[i].blob = null
      this.image[i].is = false
    },
    handleNewImage(i){
      this.image[i].is = true
      this.image[i].croppa.generateBlob((blob) => {
                this.objslike[i] = blob
            }, 'image/jpeg', 0.9)
    },
    uploadCroppedImage() {

   },

  async sacuvaj () {

    if(!this.objslike[0]){
      alert('Molim ubacite početnu sliku oglasa => 1.sl. Početna')
      return
     }
     // let result = await this.packimages()
     // if (result) {
       var obj={}
       obj.id = this.singlpro.pro_id
       obj.opis = this.opis
       obj.slike = this.objslike

     // }
    try {
      let confirm =window.confirm('Da li ste sigurni da zelite sačuvate izmene ?')
      if(confirm){
        await this.updateproduct(obj)
      }else{
        return
      }

    } catch (err) {
      console.log(err)
    }
    finally{

         this.objslike=[]
         this.image.forEach((sl)=>{
         sl.croppa = {}
         sl.is = false
         sl.url = ''
         sl.blob = null
       })
       alert('Uspesno ste sacuvali izmene !')


    }
  },
  onFileTypeMismatch (index) {
    alert('Ne poznat format. Molimo Vas odaberite .jpg , .jpeg ili .png format.')
    return
  },
  onFileSizeExceed (index) {
    alert('Velicina fajla je prevelika. Molimo Vas odaberite sliku manju od 3Mb.')
    return
  },

async  delpro(pro,index){
    var result = window.confirm('Da li ste sigurni da zelite da obrisete oglas ?')
    if(!result){
      return
    }
    await this.delproduct(pro)
    try {
      this.getuserpro(window.localStorage.getItem('uid'))
    } catch (e) {

    } finally {

    }

  },
  ...mapMutations([
    'setedit'

  ]),
  ...mapActions([
    'updateproduct'

  ]),

},
mounted(){
    // this.editpro(this.zaizmenu)

  }


}
</script>

<style lang="css" scoped>
.fa-minus-square{
  color: var(--crvena)
}

</style>



// WEBPACK FOOTER //
// src/components/izmeni.vue